import React from 'react';
import { Line } from 'react-chartjs-2';
import palette from 'theme/palette';
import useClasses from '../../../helpers/useClasses';


const styles = theme => ({
  root: {},
  chartContainer: {
    height: 400,
    position: 'relative'
  },
  actions: {
    justifyContent: 'flex-end'
  }
});

const Chart = props => {
  const { data } = props;
  const classes = useClasses(styles);

  const chart_data = {
    labels: data.labels,
    datasets: [
      {
        label: 'Searches',
        borderColor: '#01579b',
        data: data.searches,
        fill: false,
        tension: 0
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    animation: false,
    legend: { display: false },
    cornerRadius: 20,
    tooltips: {
      enabled: true,
      mode: 'index',
      intersect: false,
      borderWidth: 1,
      borderColor: "#eee",
      backgroundColor: "#fff",
      titleFontColor: palette.text.primary,
      bodyFontColor: palette.text.secondary,
      footerFontColor: palette.text.secondary
    },
    layout: { padding: 0 },
    scales: {
      xAxes: [
        {
          barThickness: 12,
          maxBarThickness: 10,
          barPercentage: 0.5,
          categoryPercentage: 0.5,
          ticks: {
            fontColor: palette.text.secondary
          },
          gridLines: {
            display: false,
            drawBorder: false
          }
        }
      ],
      yAxes: [
        {
          ticks: {
            fontColor: palette.text.secondary,
            // beginAtZero: true,
            min: 0,
            stepSize: 5
          },
          gridLines: {
            borderDash: [2],
            borderDashOffset: [2],
            color: palette.divider,
            drawBorder: false,
            zeroLineBorderDash: [2],
            zeroLineBorderDashOffset: [2],
            zeroLineColor: palette.divider
          }
        }
      ]
    }
  }

  return (
    <div className={classes.chartContainer}>
      <Line
        data={chart_data}
        options={options}
      />
    </div>
  );
};

export default Chart